import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

    if (!sessionId) {
      navigate("/auth/login", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await axios.post(`${API}/auth/google/callback`, { session_id: sessionId });
        const { access_token, refresh_token, user } = response.data;

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        setAuthData(access_token, user);

        toast.success("Welcome!", { description: `Signed in as ${user.full_name}` });

        // Redirect based on role
        if (user.role === "super_admin") navigate("/admin/dashboard", { replace: true });
        else if (user.role === "tenant_admin") navigate("/tenant/dashboard", { replace: true });
        else if (user.role === "manager") navigate("/manager/dashboard", { replace: true });
        else navigate("/learner/dashboard", { replace: true });
      } catch (error) {
        console.error("OAuth callback error:", error);
        toast.error("Sign-in failed", { description: "Could not complete Google sign-in" });
        navigate("/auth/login", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
